import { useNavigate, useLocation, useParams } from "react-router-dom";

//MUI
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";

//assets
import { ReactComponent as HomeIcon } from "../../assets/house.svg";
import { ReactComponent as NextIcon } from "../../assets/chevron_right.svg";
import { ReactComponent as NextIconCol } from "../../assets/chevron_right_col.svg";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "0.3rem",
  height: "25px",
  padding: "1rem",
  marginBottom: "0.5rem",
  "& svg": {
    width: "20px",
    height: "20px",
    [theme.breakpoints.down("xl")]: {
      width: "18px",
      height: "18px",
    },
    [theme.breakpoints.down("xl")]: {
      width: "18px",
      height: "18px",
    },
  },
  "& .header": {
    fontSize: "15px",
    fontWeight: "400",
    cursor: "pointer",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("xl")]: {
      fontSize: "13px",
    },
  },
}));


const mappings = {
  "explore_ai": "Explore AI",
  "events": "Explore Events",
};

const AIBreadCrumbs = () => {
  // const navigate = useNavigate();
  const navigate = useNavigate();
  const location = useLocation();
  // const { eventId } = useParams();
  const {eventId, subEventId, rootId } = useParams();

  const segments = location.pathname.replace("/app/", "").split("/");

  const handleNavigate = (to) => {
    navigate(`/app/${to}`);
  };



  return (
    <Container>
      <HomeIcon onClick={() => navigate(`/app/work_board`)} />
      {segments.map((segment, index) => {
        const pathUpToHere = segments.slice(0, index + 1).join("/");
        const isLast = index === segments.length - 1;
        return (
          <div key={pathUpToHere} style={{ display: "flex", alignItems: "center" }}>
            <NextIcon />

            <Typography
              className="header"
              onClick={() => handleNavigate(pathUpToHere)}
              sx={{
                cursor: !isLast ? "pointer" : "default",
                color: isLast ? "#4c639bff" : "#787575",
                fontWeight: isLast ? 600 : 400,
                marginLeft: "0.25rem",
              }}
            >
              
              {
                eventId && segment === eventId 
                  ? "Individual Event"
                  
                  // : segment == subEventId
                  //   ? "Timeline"
                    : mappings[segment] || segment
              }

            </Typography>
          </div>
        );
      })}
    </Container>
  );
};

export default AIBreadCrumbs;